import "./eventDescriptionList.styles.scss";

const EventDescriptionList = ({header, list}) => {
    return (
        <>
            <div className="list">
                <h3 className="list__header u-margin-bottom-tiny">{header}</h3>
                <ul className="list__items">
                    {list.map((item) => (
                        <li className="list__item"><span className="list__icon">&#x2713;</span> {item}</li>
                    ))}
                </ul>
            </div>
        </>
    )
}

export default EventDescriptionList;